import React, { useContext, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const success = params.get("state") === "success";

  useEffect(() => {
    if (success) clearCart();
  }, [clearCart, success]);

  return (
    <main className="pay-success pay-success--missing">
      <section className="pay-success__missing" aria-live="polite">
        <p className="pay-success__eyebrow">{siteConfig.wordmark} / PAYMENT</p>
        <h1>{success ? "PAYMENT SUCCESSFUL." : "PAYMENT CANCELLED."}</h1>
        <p>{success ? "Your payment was completed. Order updates will be sent to the email supplied at checkout." : "No completed payment was recorded. Your bag is still available if you would like to try again."}</p>
        <Link className="pay-success__button" to={success ? "/shop" : "/checkout"}>{success ? "CONTINUE SHOPPING" : "RETURN TO CHECKOUT"}</Link>
      </section>
    </main>
  );
}
